import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {
    Sizes,
    LegacyCityPropType,
    isWidget,
    Config,
} from '@ratehub/base-ui';
import { SCENARIO_TYPES } from '@ratehub/mtg-common';
import { PaymentCalculator } from '@ratehub/calculators';
import { SaveToProfileButton } from '@ratehub/base-ui';

import PAGE_TEMPLATES from '../definitions/PageTemplates';
import MORTGAGE_CALCULATOR_SIGN_IN_MESSAGES from '../definitions/MortgageCalculatorSignInMessages';
import AdvertisingDisclosure from './AdvertisingDisclosure';


const CLASS_NAME_SAVE_TO_PROFILE_CONTAINER = 'save-to-profile-button-container';
const DATA_NAME_SAVE_TO_PROFILE = 'mtg-payment-SaveToProfile';

function MortgagePaymentCalculator({
    showAdDisclosure,
    scenario,
    initialProvinceCode,
    initialCity,
    monthlyExpenseIntroduction,
    cashNeededIntroduction,
    preferredProvider,
    ...otherProps
}){
    const shouldShowSaveToProfileButton = Config.ENABLE_SAVE_TO_PROFILE_BUTTON_PAYMENT_CALC && !isWidget();

    return (
        <Container>
            <If condition={shouldShowSaveToProfileButton}>
                <div
                    className={CLASS_NAME_SAVE_TO_PROFILE_CONTAINER}
                >
                    <SaveToProfileButton
                        dataName={DATA_NAME_SAVE_TO_PROFILE}
                        signInMessages={MORTGAGE_CALCULATOR_SIGN_IN_MESSAGES}
                    />
                </div>
            </If>

            <PaymentCalculator
                className="calculator"
                scenario={scenario}
                initialProvinceCode={initialProvinceCode}
                initialCity={initialCity}
                monthlyExpenseIntroduction={monthlyExpenseIntroduction}
                cashNeededIntroduction={cashNeededIntroduction}
                preferredProvider={preferredProvider}
                {...otherProps}
            />

            <If condition={showAdDisclosure}>
                <AdvertisingDisclosure
                    className="rh-display-flex rh-mt-1 rh-ml-auto"
                    size="extra-small"
                />
            </If>

            <If condition={shouldShowSaveToProfileButton}>
                <div
                    className={CLASS_NAME_SAVE_TO_PROFILE_CONTAINER}
                >
                    <SaveToProfileButton
                        dataName={DATA_NAME_SAVE_TO_PROFILE}
                        signInMessages={MORTGAGE_CALCULATOR_SIGN_IN_MESSAGES}
                    />
                </div>
            </If>
        </Container>
    );
}

MortgagePaymentCalculator.propTypes = {
    showAdDisclosure: PropTypes.bool,
    scenario: PropTypes.oneOf([
        SCENARIO_TYPES.PURCHASE,
        SCENARIO_TYPES.RENEWAL,
    ]),
    initialProvinceCode: PropTypes.string,
    initialCity: LegacyCityPropType,
    monthlyExpenseIntroduction: PropTypes.string,
    cashNeededIntroduction: PropTypes.string,
    preferredProvider: PropTypes.string,
};

MortgagePaymentCalculator.defaultProps = {
    showAdDisclosure: true,
    scenario: SCENARIO_TYPES.PURCHASE,
    initialProvinceCode: undefined,
    initialCity: undefined,
    monthlyExpenseIntroduction: undefined,
    cashNeededIntroduction: undefined,
    preferredProvider: undefined,
};

const CONTAINER_MAX_WIDTH = '75rem';

const Container = styled.section`
    padding: ${Sizes.SPACING.HALF} 0;

    max-width: ${CONTAINER_MAX_WIDTH};

    > .${CLASS_NAME_SAVE_TO_PROFILE_CONTAINER} {
        display:flex;
        justify-content: flex-end;
        margin: ${Sizes.SPACING.HALF} auto;
    }

    > .calculator {
        margin: 0 auto;
    }
`;

MortgagePaymentCalculator.blockKey = 'rh/mortgage-payment-calculator';
MortgagePaymentCalculator.requiresLayoutRow = true;
MortgagePaymentCalculator.supportedPageTypes = [ PAGE_TEMPLATES.calculatorsMtg ];

export default MortgagePaymentCalculator;
